import CalendarIcon from "@mui/icons-material/CalendarTodayRounded";
import NumbersIcon from "@mui/icons-material/NumbersRounded";
import PersonIcon from "@mui/icons-material/PersonOutlineRounded";
import { Stack, Typography } from "@mui/material";
import UserWithAvatar from "@entrilia/shared/components/UserWithAvatar";
import CubeIcon from "@entrilia/shared/icons/CubeIcon";
import SelectIcon from "@entrilia/shared/icons/SelectIcon";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { Approval } from "../../../api/types/approvalTypes";
import { approvalItemTypeCaptionsMap } from "../../../utilities/enumCaptions";
import InlineAttribute from "../../common/InlineAttribute";
import type { RequestOrigin } from "../ApprovalWidget";
import { getApprovalProgress } from "../approvalsHelper";
import ApprovalStatusTag from "../ApprovalStatusTag";

interface Props {
  approval: Approval;
  requestOrigin?: RequestOrigin;
}

const ApprovalDetailsInfoSection = ({ approval, requestOrigin }: Props) => {
  const requestedByUserName = requestOrigin?.requestedByUserName ?? approval.createdByUserName;
  const requestedAt = requestOrigin?.requestedAt ?? approval.createdAt;
  const showLastModified = !!requestOrigin;

  return (
    <Stack spacing={0.5}>
      <Typography variant="h6" sx={{ pb: 1.5 }}>
        Request Details
      </Typography>
      <InlineAttribute
        Icon={CubeIcon}
        label="Type"
        labelWidth="10rem"
        value={approvalItemTypeCaptionsMap[approval.itemType]}
      />
      <InlineAttribute
        Icon={PersonIcon}
        label="Requested by"
        labelWidth="10rem"
        value={<UserWithAvatar userName={requestedByUserName} avatarSize="small" />}
      />
      <InlineAttribute
        Icon={CalendarIcon}
        label="Requested at"
        labelWidth="10rem"
        value={convertISODateTime(requestedAt)}
      />
      {showLastModified && (
        <>
          <InlineAttribute
            Icon={PersonIcon}
            label="Last modified by"
            labelWidth="10rem"
            value={<UserWithAvatar userName={approval.createdByUserName} avatarSize="small" />}
          />
          <InlineAttribute
            Icon={CalendarIcon}
            label="Last modified at"
            labelWidth="10rem"
            value={convertISODateTime(approval.createdAt)}
          />
        </>
      )}
      <InlineAttribute
        Icon={SelectIcon}
        label="Status"
        labelWidth="10rem"
        value={<ApprovalStatusTag status={approval.status} />}
      />
      <InlineAttribute Icon={NumbersIcon} label="Steps" labelWidth="10rem" value={getApprovalProgress(approval)} />
    </Stack>
  );
};

export default ApprovalDetailsInfoSection;
